import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["breakdown", "toggle", "toggleText"];
  static values = { open: { type: Boolean, default: false } };

  toggle(event) {
    event.preventDefault();
    this.openValue = !this.openValue;
  }

  openValueChanged() {
    // Cards without a breakdown (older stored results) still mount this
    // controller but render none of its targets.
    if (!this.hasBreakdownTarget) return;

    const panel = this.breakdownTarget;

    if (this.openValue) {
      panel.hidden = false;
      // Force reflow so the transition starts from the collapsed state
      void panel.offsetHeight;
      panel.classList.add("quiz-result-card__breakdown--open");
    } else {
      panel.classList.remove("quiz-result-card__breakdown--open");
      panel.addEventListener(
        "transitionend",
        () => {
          if (!this.openValue) panel.hidden = true;
        },
        { once: true },
      );
    }

    this.toggleTarget.setAttribute("aria-expanded", this.openValue);
    this.toggleTextTarget.textContent = this.openValue ? "Hide" : "Why?";
  }
}
